export default __webpack_public_path__ + "static/media/curved-vector.b53100be.svg";